module.exports = __webpack_public_path__ + "img/img_avatar.cec4ccb3.png";